import { Presentation as PresentationIcon } from "lucide-react";
import { useState } from "react";
import { Button } from "../components/ui/button";
import { useEnv } from "./env";
import { Presentation } from "./Presentation";
import { useEditor, useEditorApi } from "./store";

/** „Präsentieren“ in the editor's top bar (design documents). */
export function PresentButton() {
  const store = useEditorApi();
  const env = useEnv();
  const doc = useEditor((s) => s.doc);
  const [start, setStart] = useState<number | null>(null);
  if (doc.kind !== "design") return null;
  return (
    <>
      <Button
        variant="ghost"
        title="Präsentieren – Vollbild ab der aktuellen Seite"
        aria-label="Präsentieren"
        onClick={() => setStart(store.getState().pageIndex)}
      >
        <PresentationIcon /> <span className="hidden xl:inline">Präsentieren</span>
      </Button>
      {start !== null ? (
        <Presentation
          document={doc}
          resolveAsset={env.resolveAsset}
          startIndex={start}
          title={env.title}
          onClose={() => setStart(null)}
        />
      ) : null}
    </>
  );
}
